import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { DatabaseProvider } from '../../providers/database/database';
import { AuthProvider } from '../../providers/auth/auth';
import * as _ from "lodash";
import * as moment from "moment";
import * as Chart from "chart.js";
import * as Rx from "rxjs-compat";
import {Observable, Subject} from "rxjs-compat";
import firebase from "firebase";
import Timestamp = firebase.firestore.Timestamp;

const COLORS = {
  Eylea: "#2F5285",
  Lucentis: "#F48961",
  Ozurdex: "#df79f4",
  Avastin: "#f4eba8",
  Clindamycin: "#95f4aa",
  Dexamethasone: "#f44462",
  Beovu: "#83d3ee",
  Ocuflox: "#71c098"
}

@IonicPage()
@Component({
  selector: 'page-reports',
  templateUrl: 'reports.html',
})
export class ReportsPage {

  clinic_id: string;
  clinic_province: string;
  private ngUnsubscribe: Subject<any> = new Subject();

  orders: any[];
  startDate: string = moment().subtract(2, "months").startOf("month").format("YYYY-MM-DD");
  endDate: string = moment().format("YYYY-MM-DD");
  medications: string[];
  chart: Chart;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private database: DatabaseProvider,
    private auth: AuthProvider
  ) {

    this.medications = ["Eylea", "Lucentis"];

    this.auth.getCurrentUser().then(user => {
      this.clinic_id = user.clinic_id;
      this.clinic_province = user.clinic_province;

      //let lookback_date = firebase.firestore.Timestamp.fromDate(moment().subtract(2, 'months').startOf('month').toDate());
      const startDate = Timestamp.fromDate(moment(this.startDate).startOf("day").toDate());
      const endDate = Timestamp.fromDate(moment(this.endDate).endOf("day").toDate());

      this.database.getOrdersbyClinicWithDateRange(this.clinic_id, startDate, endDate).valueChanges()
        .takeUntil(this.ngUnsubscribe)
        .subscribe((orders) => {
          if (orders.length > 0) {
            this.orders = orders;
            let data = this.getMonthlyOrdersData(orders, this.medications);
            this.buildMonthlyOrdersChart(data);
          }
        });
    })
  }

  getMonthlyOrdersData(orders, medications: string[]) {
    let data: any  = {};
    medications.forEach((med) => {
      data[med] = [0];
    })
    data["Total"] = [0];
    let currentMoment = moment.unix(orders[0].createdAt.seconds).date(1);
    let nextMoment;
    let months = [currentMoment.format("MMM YYYY")];
    let counter = 0;
    for (let i = 0; i < orders.length; i++) {
      nextMoment = moment.unix(orders[i].createdAt.seconds).date(1);
      if (currentMoment.month() != nextMoment.month() || currentMoment.year() != nextMoment.year()) {
        counter++;
        for (let drug in data) {
          data[drug].push(0);
        }
        months.push(nextMoment.format("MMM YYYY"));
        currentMoment = nextMoment;
      }
      for (let drug in data) {
        switch (drug) {
          case "Eylea":
            data[drug][counter] += orders[i].Eylea_vial;
            data[drug][counter] += orders[i].Eylea_PFS;
            break;
          case "Lucentis":
            data[drug][counter] += orders[i].Lucentis_PFS;
            data[drug][counter] += orders[i].Lucentis_vial;
            break;
          case "Avastin":
            data[drug][counter] += orders[i].Avastin;
            break;
          case "Ozurdex":
            data[drug][counter] += orders[i].Ozurdex;
            break;
          case "Clindamycin":
            data[drug][counter] += orders[i].Clindamycin_PFS;
            break;
          case "Dexamethasone":
            data[drug][counter] += orders[i].Dexamethasone_PFS;
            break;
          case "Ocuflox":
            data[drug][counter] += (orders[i].Ocuflox? orders[i].Ocuflox : 0);
            break;
          case "Beovu":
            data[drug][counter] += (orders[i].Beovu? orders[i].Beovu: 0);
            break;
          case "Total":
            data[drug][counter] += orders[i].Total;
        }
      }
    }

    data["months"] = months;
    return data;
  }

  // updateLookback(lookback) {
  //   let lookback_date = firebase.firestore.Timestamp.fromDate(moment().subtract(lookback-1, 'months').startOf('month').toDate());
  //
  //   this.database.getOrdersbyClinicWithLookback(this.clinic_id, lookback_date).valueChanges()
  //     .takeUntil(this.ngUnsubscribe)
  //     .subscribe((orders) => {
  //       if (orders) {
  //         this.orders = orders;
  //         let data = this.getMonthlyOrdersData(orders, this.medications);
  //
  //         this.chart.data.labels = data['months'];
  //         this.chart.data.datasets.forEach((dataset) => {
  //           dataset.data = data[dataset.label]
  //         });
  //
  //         this.chart.update();
  //       }
  //     });
  // }

  updateDateRange() {
    console.log(this.endDate);
    const startDate = Timestamp.fromDate(moment(this.startDate).startOf("day").toDate());
    const endDate = Timestamp.fromDate(moment(this.endDate).endOf("day").toDate());

    this.database.getOrdersbyClinicWithDateRange(this.clinic_id, startDate, endDate).valueChanges()
      .takeUntil(this.ngUnsubscribe)
      .subscribe((orders) => {
        if (orders.length > 0) {
          this.orders = orders;
          let data = this.getMonthlyOrdersData(orders, this.medications);

          this.chart.data.labels = data['months'];
          this.chart.data.datasets.forEach((dataset) => {
            dataset.data = data[dataset.label]
          });

          this.chart.update();
        }
      });
  }

  updateMedications() {
    console.log(this.medications);
    const data = this.getMonthlyOrdersData(this.orders, this.medications);
    let datasets = [];
    this.medications.forEach((med) => {
      datasets.push({
        label: med,
        backgroundColor: COLORS[med],
        borderColor: COLORS[med],
        data: data[med],
        borderWidth: 1,
        fill: false
      })
    });
    this.chart.data.datasets = [...datasets,
      {
        type: "line",
        label: 'Total',
        backgroundColor: "#ca2619",
        borderColor: "#ca2619",
        data: data["Total"],
        fill: false
      }];

    this.chart.update();
    //this.buildMonthlyOrdersChart(data);
  }

  buildMonthlyOrdersChart(data: any) {
    const ctx = document.getElementById("monthlyChart");
    let datasets = [];
    this.medications.forEach((med) => {
      datasets.push({
        label: med,
        backgroundColor: COLORS[med],
        borderColor: COLORS[med],
        data: data[med],
        borderWidth: 1,
        fill: false
      })
    });
    this.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: data["months"],
        datasets: [ ...datasets,
          {
            type: "line",
            label: 'Total',
            backgroundColor: "#ca2619",
            borderColor: "#ca2619",
            data: data["Total"],
            fill: false
          }
        ]
      },
      options: {
        // title: {
        //   display: true,
        //   text: 'Eylea and Lucentis Orders By Month',
        //   position: "top",
        //   fontSize: 18
        // },
        scales: {
          yAxes: [{
            ticks: {
              beginAtZero: true
            }
          }]
        }
      }
    })
  }

  ngOnDestroy() {
    console.log('Leave reports and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/pages/reports/reports.ts